export default __webpack_public_path__ + "static/media/Declaration of Independence_02.eb9d275a.jpg";